import React, { useContext, useMemo } from 'react';
import { Row, Col } from 'react-bootstrap';
import Typewriter from 'typewriter-effect';
import ThemeContext from '../../context';
import AnimationContainer from '../../components/animation-container';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faReact,
  faDrupal,
  faGithub,
  faSass,
  faCss3,
  faWordpress,
  faNodeJs,
  faCodepen,
  faInternetExplorer,
} from '@fortawesome/free-brands-svg-icons';
import { faCode } from '@fortawesome/free-solid-svg-icons';

const Hero = ({ id }) => {
  const context = useContext(ThemeContext);

  const items = useMemo(
    () => [
      { name: faReact },
      { name: faDrupal },
      { name: faGithub },
      { name: faSass },
      { name: faCss3 },
      { name: faWordpress },
      { name: faNodeJs },
      { name: faCodepen },
      { name: faCode },
      { name: faInternetExplorer },
    ],
    []
  );

  const iconPositions = useMemo(
    () =>
      items.map((value, index) => ({
        icon: value.name,
        direction: Math.floor(Math.random() * 10) % 2 === 0 ? 'up' : 'down',
        left: `${index * 8}%`,
        top: `${
          Math.random() *
            (+(index % 2 === 0 ? 50 : 20) - +(index % 2 === 0 ? 70 : 10)) +
          +(index % 2 === 0 ? 70 : 10)
        }%`,
      })),
    [items]
  );

  const navScroll = () => {
    document.querySelector('.about')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  const showIcons = () =>
    iconPositions.map((item, index) => (
      <FontAwesomeIcon
        key={index}
        icon={item.icon}
        className={`move-${item.direction} float-image`}
        style={{
          left: item.left,
          top: item.top,
        }}
      />
    ));

  return (
    <section
      id={id}
      className='hero'
      tabIndex={0}
      style={{ height: context.height }}
    >
      <Row>
        <Col md={7} className='content'>
          <div className='content-text'>
            <AnimationContainer delay={800} animation='fadeIn slow'>
              <h2>WE create</h2>
            </AnimationContainer>

            <Typewriter
              options={{
                strings: [
                  'Functional Websites',
                  'Awesome Mobile Apps',
                  'Beautiful Graphics',
                ],
                autoStart: true,
                loop: true,
              }}
            />

            <button className='hover-button' onClick={navScroll}>
              <span>Start scrolling</span>
            </button>
          </div>
        </Col>

        <Col md={5} className='images-wrapper'>
          <AnimationContainer delay={800} animation='fadeIn slow'>
            {showIcons()}
          </AnimationContainer>
        </Col>
      </Row>
    </section>
  );
};

export default Hero;
